<template>
    <div :class="[addon||addonSlot||prepend||prependSlot ? 'input-group' : '', 'form-input-text', icon ? 'input-text-icon' : '']">
      <div class="input-group-prepend" v-if="prepend || prependSlot">
        <span class="input-group-addon">
          <span v-if="prepend" v-html="prepend" />
          <slot name="prepend"></slot>
        </span>
      </div>
      <input 
        ref="inputField"
        v-bind:type="type"
        :class="['form-control', variant, hasError() ? 'is-invalid' : '']"
        :width="width"
        v-bind:value="value"
        v-on:input="inputUpdated"
        :placeholder="placeholder"
        :maxlength="maxlength"
        :min="min"
        @keypress="onKeypress"
        @keydown.enter="onEnterPressed"
        @keydown.tab="$emit('tab', $event)"
        @blur="$emit('blur', $event)"
        @focus="$emit('focus', $event)"
        @click="$emit('click', $event)"
        :readonly="readonly" />
      <i :class="['fas', icon, 'input-label-icon']" v-if="icon" />
      <div v-if="addon || addonSlot" class="input-group-append">
        <span class="input-group-addon" v-if="addon" v-html="addon" />
        <slot name="addon"></slot>
      </div>
      <div class="form-invalid-feedback" v-if="hasError()">
        {{getError()}}
      </div>
      <div v-if="!hasError() && note" class="form-field-note">{{note}}</div>
    </div>
</template>

<style>
.form-input-text.input-text-icon {
  position: relative;
}
.form-input-text.input-text-icon input {
  padding-left: 30px !important;
}
.input-label-icon {
  position: absolute;
  top: 12px;
  left: 10px;
  color: #c9cbcc;
}
</style>

<script>
import formField from '@/mixins/formField'

export default {
  name: "FormInputText",
  mixins: [formField],
  props: {
    type: {
      type: String,
      default: 'text'
    },
    variant: String,
    value: [String, Number],
    placeholder: String,
    field: String,
    note: String,
    addon: String,
    addonSlot: Boolean,
    prepend: String,
    prependSlot: Boolean,
    readonly: Boolean,
    icon: String,
    min: [String, Number],
    wholeNumber: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 20
    },
    maxlength: {
      type: Number,
      default: null
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      // Reset error when typing if the field was blank
      // Not 100% fix to clearing errors (eg, some errors may be logic based) but helpful
      if(oldVal == '' || oldVal == null)
        this.resetFieldError(this.$props.field)

      // Default to empty string if null given
      if(newVal == null) {
        this.$nextTick(() => {
          this.$emit('input', '')
        })
      }
    }
  },
  mounted() {
  },
  methods: {
    hasError() {
      return this.getFieldError(this.$props.field).length > 0
    },
    getError() {
      return this.getFieldError(this.$props.field)
    },
    focus() {
      this.$refs.inputField.focus()
    },
    select() {
      this.$refs.inputField.select()
    },
    blur() {
      this.$refs.inputField.blur()
    },
    setSelectionRange(selectionStart, selectionEnd) {
      this.$refs.inputField.setSelectionRange(selectionStart, selectionEnd)
    },
    onEnterPressed(ev) {
      this.$emit('enter', ev)      
    },
    inputUpdated(evt) {
      this.$emit('input', evt.target.value)
    },
    onKeypress(evt) {
      if(this.wholeNumber) {
        // Disallow decimal places for whole numbers
        let keyCode = (evt.keyCode ? evt.keyCode : evt.which)
        if(keyCode === 46)
          return evt.preventDefault()
      }
    },
    insertTextAtCursor(insertText) {
      var startPos = this.$refs.inputField.selectionStart
      var endPos = this.$refs.inputField.selectionEnd
      var cursorPos = startPos
      var curValue = '' + this.value
      
      var updatedContent = curValue.substring(0, startPos) + insertText + curValue.substring(endPos, curValue.length)

      this.$emit('input', updatedContent)

      // Move cursor
      setTimeout(() => {
        cursorPos += insertText.length
        this.$refs.inputField.selectionStart = this.$refs.inputField.selectionEnd = cursorPos
      }, 10)
    }
  }
};
</script>